import { useCallback } from "react";

import { useApiContext } from "../../../../api/context";

export const useValidateRegEx = (setError?: (error: boolean) => void) => {
  const api = useApiContext();
  const validateInputForRE2 = useCallback(
    async (inputValue: string) => {
      try {
        await api.request({
          method: "post",
          url: "/v1/regexp",
          data: {
            regexp: inputValue,
          },
        });
        setError?.(false);
        return true;
      } catch (err: unknown) {
        setError?.(true);
        return false;
      }
    },
    [api, setError]
  );
  return { validateInputForRE2 };
};
